<div mat-dialog-content>
    <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions style="display: flex; justify-content: flex-end; gap: 8px;">
    <button mat-button (click)="onCancel()">{{ data.cancelText || 'Cancel' }}</button>
    <button mat-raised-button color="primary" (click)="onConfirm()">{{ data.confirmText || 'Confirm' }}</button>
</div>
